module.exports = __webpack_public_path__ + "img/welcome-desktop-1.cadb9e7a.png";